"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const LoaderWrapper = styled_components_1.default.div `
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  position: absolute;
  top: 50%;
  margin-top: -32px;
  left: 50%;
  margin-left: -32px;
  img {
    border: 0;
    display: block;
    width: 100%;
    height: 100%;
  }
`;
const Loader = () => (react_1.default.createElement(LoaderWrapper, { "data-testid": "loader-wrapper" },
    react_1.default.createElement("img", { src: "/images/other/loader.svg", alt: "" })));
exports.default = Loader;
